















































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import EditorWithFile from "@/components/EditorWithFile.vue";
import api from "@/getinfo-api";
import { isRoot } from "@/plugins/roles";
import { User as IUser } from "@/api/models/user";
import { UserEdit as IUserEdit } from "@/api/models/user-edit";
import { UserChangePassword as IUserChangePassword } from "@/api/models/user-change-password";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { AxiosError } from "axios";
import { getCurrentUserId } from "@/plugins/roles";
import { UserDocumentInfoEdit as IUserDocumentInfoEdit } from "@/api/models/user-document-info-edit";
import { UserDocumentInfo as IUserDocumentInfo } from "@/api/models/user-document-info";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import moment from "moment/moment";
import {
  bookkeepingModule,
  learningDocumentsModule
} from "@/plugins/modules-detect";
import CustomButton from "@/components/form/CustomButton.vue";
import FileManager from "@/components/files/FileManager.vue";
import UserNotificationSettings from "@/components/user/UserNotificationSettings.vue";
import CustomInputPhone from "@/components/form/CustomInputPhone.vue";
import { FileItem as IFileItem } from "@/api/models/file-item";
import UserAvatar from "@/components/user/UserAvatar.vue";
import { screenWidth } from "@/plugins/variables";
import CField from "@/components/form/CField.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import { UserResetUserPassword } from "@/api/models";
import { i18n } from "@/locales/settings";
import { LocalesFields } from "@/locales/translateInterface";
import { UserSettings as IUserSettings } from "@/api-v2/notification/models/user-settings";
import { NotificationSettingsTypes, User } from "@/services/notifications";

@Component({
  components: {
    UserNotificationSettings,
    CBlock,
    CField,
    CustomInputPhone,
    UserAvatar,
    FileManager,
    CustomButton,
    EditorWithFile,
    CustomDatepicker
  }
})
export default class UserProfileForm extends Vue {
  @Prop() user!: IUser;
  @Prop() notificationSettings?: {
    course: IUserSettings;
    test: IUserSettings;
    order: IUserSettings;
  };
  gettedUser!: IUser;
  userDocumentInfo!: IUserDocumentInfo;
  userEnable!: boolean | undefined;
  gender!: number | undefined;
  aboutMe!: string | undefined;
  firstName!: string | undefined;
  lastName!: string | undefined;
  phone!: string | undefined;
  email!: string | undefined;
  middleName!: string | undefined | null;
  vk!: string | undefined;
  ok!: string | undefined;
  fb!: string | undefined;
  skype!: string | undefined;
  telegram!: string | undefined;
  viber!: string | undefined;
  whatsapp!: string | undefined;
  birthday?: string | undefined;
  showPasswordFormSwitch: boolean = false;
  oldPassword!: string | undefined;
  newPassword!: string | undefined;
  newPasswordRepeat!: string | undefined;
  position!: string | undefined;
  snils!: string | undefined;
  address!: string | undefined;
  postAddress!: string | undefined;
  education!: string | undefined;
  educationSeries!: string | undefined;
  educationNumber!: string | undefined;
  educationRegistrationNumber!: string | undefined;
  educationSurname!: string | undefined;
  educationInstitution!: string | undefined;
  educationDate!: Date | undefined;
  citizenship: string | undefined;
  isShowFileManager: boolean = false;
  selectedUserPhoto!: IFileItem | null;
  job!: string | undefined;
  firstNameDative!: string | undefined;
  lastNameDative!: string | undefined;
  middleNameDative!: string | undefined;
  passportSeries: string = "";
  passportNumber: string = "";
  passportIssuedBy: string = "";
  whenPassportIssued: string = "";
  notificationSettingsOrder?: IUserSettings = {
    emailNotification: false,
    notification: false
  };
  notificationSettingsTesting?: IUserSettings = {
    emailNotification: false,
    notification: false
  };
  notificationSettingsCourseEnrollment?: IUserSettings = {
    emailNotification: false,
    notification: false
  };

  data() {
    return {
      citizenship: undefined,
      gettedUser: undefined,
      gender: undefined,
      userDocumentInfo: undefined,
      userId: this.$route.params.id,
      aboutMe: undefined,
      firstName: undefined,
      lastName: undefined,
      phone: undefined,
      vk: undefined,
      ok: undefined,
      fb: undefined,
      skype: undefined,
      telegram: undefined,
      viber: undefined,
      whatsapp: undefined,
      birthday: undefined,
      oldPassword: undefined,
      newPassword: undefined,
      newPasswordRepeat: undefined,
      userEnable: undefined,
      position: undefined,
      snils: undefined,
      address: undefined,
      postAddress: undefined,
      education: undefined,
      educationNumber: undefined,
      educationSeries: undefined,
      educationDate: undefined,
      educationRegistrationNumber: undefined,
      educationSurname: undefined,
      email: undefined,
      educationInstitution: undefined,
      selectedUserPhoto: this.user?.photo ? this.user?.photo : undefined,
      job: undefined,
      firstNameDative: undefined,
      lastNameDative: undefined,
      middleNameDative: undefined
    };
  }

  get screenWidth() {
    return screenWidth();
  }

  get notificationTypes() {
    return NotificationSettingsTypes;
  }

  selectFile(file: IFileItem) {
    this.selectedUserPhoto = file;
    if (this.screenWidth < 992) {
      this.isShowFileManager = false;
    }
  }

  showPasswordForm() {
    this.showPasswordFormSwitch
      ? (this.showPasswordFormSwitch = false)
      : (this.showPasswordFormSwitch = true);
  }

  hardResetPassword() {
    if (this.root) {
      if (
        this.newPasswordRepeat &&
        this.newPassword &&
        this.newPasswordRepeat === this.newPassword
      ) {
        let form: UserResetUserPassword = {
          password: this.newPassword
        };
        api.UsersApi.resetUserPassword(this.user.id, form).then(() => {
          this.$bvToast.toast(
            this.$tc(this.$translate.TheInformationHasBeenSuccessfullyChanged),
            {
              variant: "success",
              title: i18n.tc(LocalesFields.Successful)
            }
          );
          this.showPasswordForm();
        });
      } else {
        this.$bvToast.toast(this.$tc(this.$translate.PasswordsDoNotMatch), {
          variant: "danger",
          title: i18n.tc(LocalesFields.Error)
        });
      }
    }
  }

  changePassword() {
    if (this.newPassword !== this.newPasswordRepeat) {
      this.$bvToast.toast(this.$tc(this.$translate.PasswordsDoNotMatch), {
        variant: "danger",
        title: i18n.tc(LocalesFields.Error)
      });
    } else if (this.oldPassword && this.newPassword) {
      let params: IUserChangePassword = {
        oldPassword: this.oldPassword,
        newPassword: this.newPassword
      };
      api.UsersApi.changePassword(this.currentUserId, params)
        .then(() => {
          this.$bvToast.toast(
            this.$tc(this.$translate.TheInformationHasBeenSuccessfullyChanged),
            {
              variant: "success",
              title: i18n.tc(LocalesFields.Successful)
            }
          );
          this.showPasswordForm();
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  changeUserStatus() {
    if (!this.userEnable) {
      api.UsersApi.disable(this.user.id)
        .then((res: { data: IUser }) => {
          this.userEnable = res.data.enabled;
        })
        .then(() => {
          this.successUpdate();
        })
        .catch(
          (error: AxiosError<IErrorResponse | IValidationErrorResponse>) => {
            if (error.response) {
              this.$bvToast.toast(error.response.data.message, {
                variant: "danger",
                title: i18n.tc(LocalesFields.Error)
              });
            } else {
              this.$bvToast.toast(this.$tc(this.$translate.UnknownError), {
                variant: "danger",
                title: i18n.tc(LocalesFields.Error)
              });
            }
          }
        );
    } else {
      api.UsersApi.enable(this.user.id)
        .then((res: { data: IUser }) => {
          this.userEnable = res.data.enabled;
        })
        .then(() => {
          this.$bvToast.toast(
            this.$tc(this.$translate.TheInformationHasBeenSuccessfullyChanged),
            {
              variant: "success",
              title: i18n.tc(LocalesFields.Successful)
            }
          );
        })
        .catch(
          (error: AxiosError<IErrorResponse | IValidationErrorResponse>) => {
            if (error.response) {
              this.$bvToast.toast(error.response.data.message, {
                variant: "danger",
                title: i18n.tc(LocalesFields.Error)
              });
            } else {
              this.$bvToast.toast(this.$tc(this.$translate.UnknownError), {
                variant: "danger",
                title: i18n.tc(LocalesFields.Error)
              });
            }
          }
        );
    }
  }

  fileDelete() {
    this.selectedUserPhoto = null;
  }

  successUpdate() {
    this.$bvToast.toast(
      this.$tc(this.$translate.TheInformationHasBeenSuccessfullyChanged),
      {
        variant: "success",
        title: i18n.tc(LocalesFields.Successful)
      }
    );
  }

  get currentUserId() {
    return getCurrentUserId();
  }

  getDocumentInformation() {
    api.UsersApi.getDocumentInfo(this.user.id)
      .then((res: { data: IUserDocumentInfo }) => {
        this.userDocumentInfo = res.data;
        this.position = this.userDocumentInfo.position;
        this.snils = this.userDocumentInfo.snils;
        this.address = this.userDocumentInfo.address;
        this.postAddress = this.userDocumentInfo.postAddress;
        this.education = this.userDocumentInfo.education;
        this.educationNumber = this.userDocumentInfo.educationNumber;
        this.educationSeries = this.userDocumentInfo.educationSeries;
        this.educationDate = this.userDocumentInfo?.educationDate
          ? this.$converter.date(this.userDocumentInfo.educationDate)
          : undefined;
        this.educationRegistrationNumber = this.userDocumentInfo.educationRegistrationNumber;
        this.educationSurname = this.userDocumentInfo.educationSurname;
        this.educationInstitution = this.userDocumentInfo.educationInstitution;
        this.job = this.userDocumentInfo.job;
        this.firstNameDative = this.userDocumentInfo.firstNameDative;
        this.lastNameDative = this.userDocumentInfo.lastNameDative;
        this.middleNameDative = this.userDocumentInfo.middleNameDative;
        this.passportSeries = this.userDocumentInfo.passportSeries
          ? this.userDocumentInfo.passportSeries
          : "";
        this.passportNumber = this.userDocumentInfo.passportNumber
          ? this.userDocumentInfo.passportNumber
          : "";
        this.passportIssuedBy = this.userDocumentInfo.passportIssuedBy
          ? this.userDocumentInfo.passportIssuedBy
          : "";
        this.whenPassportIssued = this.userDocumentInfo.whenPassportIssued
          ? this.userDocumentInfo.whenPassportIssued
          : "";

        if (!this.userDocumentInfo.citizenship) {
          this.citizenship = "643";
        } else {
          this.citizenship = this.userDocumentInfo.citizenship;
        }
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  editDocumentInformation() {
    let documentInfo: IUserDocumentInfoEdit = {
      position: this.position,
      snils: this.snils,
      address: this.address,
      postAddress: this.postAddress,
      education: this.education,
      educationSeries: this.educationSeries,
      educationNumber: this.educationNumber,
      educationDate: this.educationDate ? this.educationDate : undefined,
      educationRegistrationNumber: this.educationRegistrationNumber,
      educationSurname: this.educationSurname,
      educationInstitution: this.educationInstitution,
      citizenship: this.citizenship,
      job: this.job,
      firstNameDative: this.firstNameDative,
      lastNameDative: this.lastNameDative,
      middleNameDative: this.middleNameDative,
      passportSeries: this.passportSeries ? this.passportSeries : "",
      passportNumber: this.passportNumber ? this.passportNumber : "",
      passportIssuedBy: this.passportIssuedBy ? this.passportIssuedBy : "",
      whenPassportIssued: this.whenPassportIssued ? this.whenPassportIssued : ""
    };

    api.UsersApi.editDocumentInfo(this.user.id, documentInfo)
      .then(() => {
        this.$store.dispatch("GO_TO_USER_PAGE", this.gettedUser);
        // this.$router.go(-1);
        this.$bvToast.toast(
          this.$tc(this.$translate.TheInformationHasBeenSuccessfullyChanged),
          {
            variant: "success",
            title: i18n.tc(LocalesFields.Successful)
          }
        );
      })
      .catch((error: AxiosError<IErrorResponse | IValidationErrorResponse>) => {
        if (error.response) {
          this.$bvToast.toast(error.response.data.message, {
            variant: "danger",
            title: i18n.tc(LocalesFields.Error)
          });
        } else {
          this.$bvToast.toast(this.$tc(this.$translate.UnknownError), {
            variant: "danger",
            title: i18n.tc(LocalesFields.Error)
          });
        }
      });
  }

  async editProfile() {
    if (await this.$store.dispatch("validate/CHECK_VALIDATIONS")) return;
    //@ts-ignore
    const dateBirthday: Date | undefined = this.birthday
      ? moment(this.birthday).format()
      : undefined;

    if (this.root) {
      this.changeUserStatus();
    }

    let userInfo: IUserEdit = {
      firstName: this.firstName,
      lastName: this.lastName,
      phone: this.phone ?? "",
      //@ts-ignore
      middleName: this.middleName ? this.middleName : null,
      vk: this.vk,
      ok: this.ok,
      fb: this.fb,
      skype: this.skype,
      //@ts-ignore
      photoId: this.selectedUserPhoto?.id ? this.selectedUserPhoto?.id : null,
      telegram: this.telegram,
      email: this.email,
      viber: this.viber,
      whatsapp: this.whatsapp,
      gender: this.gender,
      birthday: dateBirthday,
      aboutMe: this.aboutMe
    };

    api.UsersApi.edit(this.user.id, userInfo)
      .then(async (res: { data: IUser }) => {
        this.gettedUser = res.data;

        await User.setNewLearningRequest(
          this.user.id,
          this.notificationSettings?.order!
        );
        await User.setStudentFinishLearning(
          this.user.id,
          this.notificationSettings?.test!
        );
        await User.setStudentStartLearningSettings(
          this.user.id,
          this.notificationSettings?.course!
        );

        this.editDocumentInformation();
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  created() {
    this.getDocumentInformation();
    this.getProps();
  }

  get root() {
    return isRoot();
  }

  get documentModule() {
    return bookkeepingModule() || learningDocumentsModule();
  }

  setNotificationSettings() {
    this.notificationSettingsCourseEnrollment = this.notificationSettings?.course;
    this.notificationSettingsOrder = this.notificationSettings?.order;
    this.notificationSettingsTesting = this.notificationSettings?.test;
  }

  @Watch("notificationSettings", { deep: true, immediate: true })
  updateNotificationSettings() {
    this.setNotificationSettings();
  }

  getProps() {
    if (this.user) {
      this.gender = this.user.gender;
      this.firstName = this.user.firstName;
      this.lastName = this.user.lastName;
      this.phone = this.user.phone;
      this.middleName = this.user.middleName;
      this.email = this.user.email;
      this.vk = this.user.vk;
      this.ok = this.user.ok;
      this.fb = this.user.fb;
      this.skype = this.user.skype;
      this.telegram = this.user.telegram;
      this.viber = this.user.viber;
      this.whatsapp = this.user.whatsapp;
      this.birthday = this.user.birthday
        ? moment(this.user.birthday).format("YYYY-MM-DD")
        : undefined;
      this.aboutMe = this.user.aboutMe;
      this.userEnable = this.user.enabled;
    }
  }
}
